/**
 * Canadian provinces abbreviations mapping
 * Used for displaying location addresses in short format
 */
export const CA_PROVINCE_ABBREVIATIONS: Record<string, string> = {
    Alberta: "AB",
    "British-Columbia": "BC",
    Manitoba: "MB",
    "New-Brunswick": "NB",
    "Newfoundland-and-Labrador": "NL",
    "Northwest-Territories": "NT",
    "Nova-Scotia": "NS",
    Nunavut: "NU",
    Ontario: "ON",
    "Prince-Edward-Island": "PE",
    Quebec: "QC",
    Saskatchewan: "SK",
    Yukon: "YT",
};
